import React, { Component } from "react";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleDate from "../../../../../modules/SimpleDate";
import moment from "moment";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import {
  ACTIVITY_TYPE,
  HttpStatus,
  Status,
} from "../../../../common/Constants";
import { mapToObjectDDL } from "../../../../common/mapper";
import { JENIS_PIT_OPTIONS } from "../../constant";
import { sanitizeDateTime } from "../../utils";
class TabDataTambahanFJB extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mechanicOptions: [],
      unitEntryOptions: [],
    };
  }

  componentDidMount() {
    this.loadDDL();
  }

  loadDDL = async () => {
    const { onTriggerLoading, setError, formData } = this.props;
    const kodeCabang = formData?.kodeCabang;

    const promises = [
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMechanicNameFjb,
        setError: setError,
        menuName: "Faktur Jual Bengkel",
        args: {
          cabang: [kodeCabang?.value],
        },
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizpar,
        setError: setError,
        menuName: "Faktur Jual Bengkel",
        args: {
          paramFilters: {
            bizparCategory: "UNIT_ENTRY_SOURCE",
            status: Status.ACTIVE,
          },
        },
      }),
    ];

    onTriggerLoading();
    const res = await Promise.all(promises);

    res.forEach((result, index) => {
      if (
        index === 0 &&
        result.ok &&
        result.data.status === HttpStatus.SUCCESS
      ) {
        this.setState({
          mechanicOptions: result?.data?.data?.map((item) =>
            mapToObjectDDL(item.name, item.employeeId)
          ),
        });
      }
      if (
        index === 1 &&
        result.ok &&
        result.data.status === HttpStatus.SUCCESS
      ) {
        this.setState({
          unitEntryOptions: result?.data?.data?.map((item) =>
            mapToObjectDDL(item.value, item.key)
          ),
        });
      }
    });
    onTriggerLoading();
  };

  setValue = (name, value) => {
    const { onSetSpesificData } = this.props;
    onSetSpesificData("dataTambahan", name, value);
  };

  render() {
    const { formData, tab, activityType, errors, isSO, isDirectSales } = this.props;
    const { mechanicOptions, unitEntryOptions } = this.state;
    const dataTambahan = formData?.dataTambahan || {};
    const isReadOnly = activityType === ACTIVITY_TYPE.VIEW || isSO || isDirectSales;
    const isMandatory = !isSO

    return (
      <React.Fragment>
        <div className="grid grid-2x gap-20px grid-mobile-none">
          <div id="grid-1">
            <SimpleInput
              id="input_nomor_wo"
              name="noWorkOrder"
              containerclassname="width width-full"
              label="No. Work Order"
              mandatory={isMandatory}
              errorMessage={errors?.dataTambahan?.noWorkOrder}
              readOnly={isReadOnly}
              value={dataTambahan.noWorkOrder}
              onChange={({ target }) =>
                this.setValue(target.name, target.value)
              }
            />
            <SimpleDate
              id="select_date_tanggal_service"
              name="tanggalService"
              label="Tanggal Service"
              mandatory={isMandatory}
              errorMessage={errors?.dataTambahan?.tanggalService}
              disabled={isReadOnly}
              containerclassname="width width-full"
              date={dataTambahan.tanggalService}
              onChange={(value) =>
                this.setValue(
                  "tanggalService",
                  moment(value).format("DD-MM-YYYY")
                )
              }
            />
            <SimpleInput
              id="input_waktu_pkb"
              name="waktuPkb"
              containerclassname="width width-full"
              label="Waktu PKB"
              value={dataTambahan?.waktuPkb}
              readOnly={tab === "NOS" || isReadOnly}
              onChange={({ target }) => {
                if (tab === "NOS") {
                  return;
                }
                this.setValue(target.name, target.value);
              }}
            />
            <SimpleDDL
              id="select_options_asal_unit_entry"
              name="asalUnitEntry"
              box="search"
              label="Asal Unit Entry"
              mandatory={isMandatory}
              errorMessage={errors?.dataTambahan?.asalUnitEntry}
              readOnly={isReadOnly}
              containerclassname="width width-full"
              value={dataTambahan.asalUnitEntry}
              options={unitEntryOptions}
              onChange={(value, { name }) => this.setValue(name, value)}
            />
            <SimpleDDL
              id="select_options_nama_mekanik"
              name="mekanik"
              box="search"
              label="Nama Mekanik"
              mandatory={isMandatory}
              errorMessage={errors?.dataTambahan?.mekanik}
              readOnly={isReadOnly}
              containerclassname="width width-full"
              value={dataTambahan?.mekanik}
              options={mechanicOptions}
              onChange={(value, { name }) => this.setValue(name, value)}
            />
            <SimpleDDL
              id="select_options_final_check"
              name="finalCheck"
              box="search"
              label="Final Check"
              mandatory={isMandatory}
              errorMessage={errors?.dataTambahan?.finalCheck}
              readOnly={isReadOnly}
              containerclassname="width width-full"
              value={dataTambahan?.finalCheck}
              options={mechanicOptions}
              onChange={(value, { name }) => this.setValue(name, value)}
            />
          </div>
          <div id="grid-2">
            <SimpleDDL
              id="select_options_jenis_pit"
              name="jenisPit"
              box="search"
              label="Jenis Pit"
              mandatory={isMandatory}
              errorMessage={errors?.dataTambahan?.jenisPit}
              readOnly={isReadOnly}
              containerclassname="width width-full"
              value={dataTambahan?.jenisPit}
              options={JENIS_PIT_OPTIONS}
              onChange={(value, { name }) => this.setValue(name, value)}
            />
            <SimpleInput
              id="input_waktu_pendaftaran"
              name="waktuPendaftaran"
              label="Waktu Pendaftaran"
              box="mask"
              disabled={isReadOnly}
              placeholder="dd-mm-yyyy hh:mm:ss"
              mask="99-99-9999 99:99:99"
              containerclassname="width width-full"
              value={dataTambahan.waktuPendaftaran}
              onChange={({ target }) =>
                this.setValue(
                  "waktuPendaftaran",
                  sanitizeDateTime(target.value)
                )
              }
            />
            <SimpleInput
              id="input_waktu_selesai"
              name="waktuSelesai"
              label="Waktu Selesai"
              box="mask"
              disabled={isReadOnly}
              placeholder="dd-mm-yyyy hh:mm:ss"
              mask="99-99-9999 99:99:99"
              style={{ marginBottom: "12px" }}
              containerclassname="width width-full"
              value={dataTambahan.waktuSelesai}
              onChange={({ target }) =>
                this.setValue("waktuSelesai", sanitizeDateTime(target.value))
              }
            />
            <SimpleInput
              id="input_total_frt"
              name="totalFrt"
              label="Total Frt"
              containerclassname="width width-full"
              box="mask"
              placeholder="hh:mm"
              mask="99:99"
              disabled={isReadOnly}
              value={dataTambahan.totalFrt}
              onChange={({ target }) => this.setValue("totalFrt", target.value)}
            />
            <SimpleDDL
              id="select_options_sa"
              name="sa"
              box="search"
              label="SA"
              mandatory
              errorMessage={errors?.dataTambahan?.sa}
              readOnly={activityType === ACTIVITY_TYPE.VIEW}
              containerclassname="width width-full"
              value={dataTambahan?.sa}
              options={mechanicOptions}
              onChange={(value, { name }) => this.setValue(name, value)}
            />
            <SimpleDDL
              id="options_admin_fjb"
              name="adminFjb"
              box="search"
              label="Admin FJB"
              containerclassname="width width-full"
              readOnly
              value={dataTambahan.adminFjb}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default TabDataTambahanFJB;
